module.exports = __webpack_public_path__ + "img/_star_note.25845d23.svg";